export default __webpack_public_path__ + "static/media/fietsverhuur.6f25ced4.svg";